/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @legacy
 * @alpha
 */
export const IFluidHandleContext = "IFluidHandleContext";
/**
 * @public
 * @privateRemarks
 * This really should be deprecated and alpha, but since its a merged export with the public interface,
 * it can't have its own docs or different tags.
 */
export const IFluidHandle = "IFluidHandle";
/**
 * Symbol which must only be used on an {@link (IFluidHandle:interface)}, and is used to identify such objects.
 *
 * @remarks
 * To narrow arbitrary objects to handles do not simply check for this symbol:
 * instead use {@link @fluidframework/runtime-utils#isFluidHandle} which has improved compatibility
 * with older implementations of handles that may exist due to dynamic code loading of older packages.
 *
 * @privateRemarks
 * Normally `Symbol` would be used here instead of `Symbol.for` since just using Symbol (and avoiding the global symbol registry) removes the risk of collision, which is the main point of using a symbol for this in the first place.
 * In this case however, some users of this library do dynamic code loading, and can end up with multiple versions of packages, and mix data from one version with another.
 * Using the global symbol registry allows duplicate copies of this library to share a single symbol, though reintroduces the risk of collision, which is mitigated via the use of a UUIDv4 randomly generated when this code was authored:
 * @public
 */
export const fluidHandleSymbol = Symbol.for("FluidHandle-3978c7cf-4675-49ba-a20c-bf35efbf43da");
//# sourceMappingURL=handles.js.map